// Adapted from https://usehooks.com/useLockBodyScroll/
import { useLayoutEffect } from 'react'

export function useLockBodyScroll() {
  useLayoutEffect(() => {
    document.body.classList.add('no-scroll')
    return () => document.body.classList.remove('no-scroll')
  }, [])
}
